import { Injectable, OnDestroy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TokenStorageService } from './token-storage.service';
import { Subscription } from 'rxjs';

@Injectable()
export class AutoUpdateService implements OnDestroy {
  private readonly subscriptions = new Subscription();

  constructor(private readonly swUpdate: SwUpdate, private readonly tokenStorage: TokenStorageService) {}

  public init(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.subscriptions.add(this.swUpdate.unrecoverable.subscribe(() => location.reload()));
    this.subscriptions.add(
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.swUpdate.activateUpdate().then(() => location.reload());
        }
      })
    );

    this.subscriptions.add(this.tokenStorage.userInfoChanged.subscribe(() => this.swUpdate.checkForUpdate()));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
